module.exports = __webpack_public_path__ + "img/Healthcare Collaboration, Not War Op-Ed.4820ac94.jpg";